/* nfp-more-20260917 */
(function(){var mq=window.matchMedia('(min-width:1025px)');var b=document.body;var ov=null,input=null;
function build(){if(ov)return;ov=document.createElement('div');ov.className='nf-srch';ov.innerHTML='<div class="nf-srch__bg" data-x></div><div class="nf-srch__panel" role="dialog" aria-label="Buscar en la tienda"><button type="button" class="nf-srch__x" data-x aria-label="Cerrar">&times;</button><form action="/search" method="get" class="nf-srch__form"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9A9994" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"></circle><path d="M21 21l-4.3-4.3"></path></svg><input type="search" name="q" placeholder="Buscá tu medida, marca o modelo…" autocomplete="off" aria-label="Buscar"><button type="submit" class="nf-srch__go">Buscar</button></form><div class="nf-srch__chips"><span>Populares</span><a href="/search?q=175%2F65+R14">175/65 R14</a><a href="/search?q=Michelin">Michelin</a><a href="/collections/baterias">Baterías</a><a href="/collections/neumaticos-auto">Cubiertas auto</a></div></div>';b.appendChild(ov);input=ov.querySelector('input');ov.addEventListener('click',function(e){if(e.target.closest('[data-x]'))close();});}
function open(){build();b.classList.add('nf-srch-open');setTimeout(function(){if(input)input.focus();},70);}
function close(){b.classList.remove('nf-srch-open');}
function bind(){var f=document.querySelector('.nf-header .nf-search');if(!f)return;
f.addEventListener('click',function(e){if(!mq.matches)return;e.preventDefault();open();});
var ni=f.querySelector('input');if(ni)ni.addEventListener('focus',function(){if(mq.matches){ni.blur();open();}});
document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});}
if(document.readyState!='loading')bind();else document.addEventListener('DOMContentLoaded',bind);})();

/* ===== Ficha de producto: logo de marca + titulo sin "Neumatico" ===== */
(function(){
  var t=document.querySelector('.nfp__t'); if(!t) return;
  var BR={
    'Yokohama':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/yokohama-logo.svg?v=1772562007',
    'Pirelli':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/pirelli-logo-2.svg?v=1788793336',
    'Continental':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/continental-6.svg?v=1772562601',
    'Dunlop':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/dunlop-1.svg?v=1772562045',
    'Bridgestone':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/bridgestone-3.svg?v=1772562518',
    'Firestone':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/firestone-tire.svg?v=1772562910',
    'Nexen':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/nexen-tire-logo-1.svg?v=1772562653',
    'Linglong':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/linglong-tire-logo.svg?v=1772562715',
    'Fate':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/logo-fate.svg?v=1773962753',
    'Kumho':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/kumho-logo.svg?v=1788793260'
  };
  var title=(t.textContent||'').trim();
  var brand=null;
  for(var k in BR){ if(new RegExp('\\b'+k+'\\b','i').test(title)){ brand=k; break; } }
  t.textContent=title.replace(/^Neum[aá]tico\s+/i,'');
  if(brand && !t.parentNode.querySelector('.nfp__brand')){
    var d=document.createElement('div'); d.className='nfp__brand';
    var inner= BR[brand] ? ('<img src="'+BR[brand]+'" alt="'+brand+'" height="30" draggable="false">') : ('<span>'+brand+'</span>');
    d.innerHTML='<a href="/collections/'+brand.toLowerCase()+'" aria-label="Ver '+brand+'">'+inner+'</a>';
    t.parentNode.insertBefore(d,t);
  }
})();

/* ===== Ficha: badge "-X% EFECTIVO" sobre la imagen ===== */
(function(){
  var main=document.querySelector('.nfp__main'); if(!main) return;
  function badge(){
    if(main.querySelector('.nfp__effoff')) return;
    var em=document.querySelector('.nfp__pay2 .nfp__opt--cash em'); if(!em) return;
    var m=(em.textContent||'').match(/(\d+)/); if(!m) return;
    var s=document.createElement('span'); s.className='nfp__effoff';
    s.innerHTML='<b>-'+m[1]+'%</b>';
    main.appendChild(s);
  }
  badge(); setTimeout(badge,400);
})();

/* ===== Ficha: specs y perks debajo del grid (ancho completo, sin hueco blanco) ===== */
(function(){
  var grid=document.querySelector('.nfp__grid'); if(!grid) return;
  var wrap=grid.parentNode;
  var desc=document.querySelector('.nfp__desc');
  if(desc){
    var html=desc.innerHTML||'';
    html=html
      .replace(/<h[1-6][^>]*>\s*Ficha t[eé]cnica[\s\S]*?(?=<h[1-6]|$)/i,'')
      .replace(/<h[1-6][^>]*>\s*Compr[aá] en NEUMAFLORES[\s\S]*?(?=<h[1-6]|$)/i,'')
      .replace(/<ul[\s\S]*?(Marca\s*:|Índice de carga)[\s\S]*?<\/ul>/i,'')
      .replace(/<li[^>]*>[\s\S]*?(v[aá]lvula|alineaci[oó]n)[\s\S]{0,160}?(gratis|sin cargo|inclu[ií]d|mismo lugar)[\s\S]*?<\/li>/gi,'')
      .replace(/,?\s*v[aá]lvula\s+e\s+inflado\s+inclu[ií]d[oa]s/gi,'');
    desc.innerHTML=html;
    if(!desc.textContent.replace(/\s+/g,'').length) desc.remove();
  }
  if(wrap.querySelector('.nfp__more')) return;
  var t=document.querySelector('.nfp__t'); var title=t?(t.textContent||''):'';
  var SPD={Q:'160',R:'170',S:'180',T:'190',U:'200',H:'210',V:'240',W:'270',Y:'300',Z:'240+'};
  var BRs=['Yokohama','Pirelli','Continental','Dunlop','Bridgestone','Firestone','Nexen','Linglong','Fate','Kumho','Michelin','Goodyear','Hankook','Wanli','Sunny','Westlake','West Lake'];
  var brand=''; for(var i=0;i<BRs.length;i++){ if(new RegExp('\\b'+BRs[i]+'\\b','i').test(title)){brand=BRs[i];break;} }
  var mm=title.match(/(\d{2,3})\s*\/\s*(\d{2})\s*(?:R|ZR)?\s*(\d{2})/i);
  var model='';
  if(brand && mm){ var after=title.replace(new RegExp('^.*?'+brand+'\\s*','i'),''); model=after.split(mm[0])[0].trim(); }
  var rows=[];
  if(brand) rows.push(['Marca',brand]);
  if(model) rows.push(['Modelo',model]);
  if(mm){
    rows.push(['Medida', mm[1]+'/'+mm[2]+' R'+mm[3]]);
    rows.push(['Ancho', mm[1]+' mm']);
    rows.push(['Perfil', mm[2]+'%']);
    rows.push(['Rodado', 'R'+mm[3]]);
    var rest=title.slice(title.indexOf(mm[0])+mm[0].length);
    var ls=rest.match(/(\d{2,3}(?:\/\d{2,3})?)\s*([A-Z]{1,2})\b/);
    if(ls){ rows.push(['Carga', ls[1]]); var sp=ls[2].charAt(ls[2].length-1).toUpperCase(); rows.push(['Velocidad', ls[2]+(SPD[sp]?(' · '+SPD[sp]+' km/h'):'')]); }
  }
  if(/camioneta|suv|4x4|pickup/i.test(title)) rows.push(['Uso','Camioneta / SUV']);
  else if(/\bmoto\b/i.test(title)) rows.push(['Uso','Moto']);
  var more=document.createElement('div'); more.className='nfp__more';
  if(rows.length>=3){
    var s=document.createElement('div'); s.className='nfp__specs';
    s.innerHTML='<h4>Ficha técnica</h4><div class="nfp__specgrid">'+rows.map(function(r){return '<div class="nfp__spec"><span class="k">'+r[0]+'</span><span class="v">'+r[1]+'</span></div>';}).join('')+'</div>';
    more.appendChild(s);
  }
  var TRUCK='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.6"/><circle cx="17.5" cy="18" r="1.6"/></svg>';
  var TOOL='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3"/></svg>';
  var SHIELD='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z"/><path d="M9 12l2 2 4-4"/></svg>';
  var CARD='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="6" width="18" height="12" rx="2"/><path d="M3 10h18"/></svg>';
  var P=[[TOOL,'Colocación sin cargo','Flores y Lomas'],[CARD,'Cuotas','3 y 6 con tarjeta'],[TRUCK,'Envío','A todo el país'],[SHIELD,'Garantía','Producto nuevo']];
  var w=document.createElement('div'); w.className='nfp__perks';
  w.innerHTML=P.map(function(p){return '<div class="nfp__perk">'+p[0]+'<div><b>'+p[1]+'</b><span>'+p[2]+'</span></div></div>';}).join('');
  more.appendChild(w);
  grid.parentNode.insertBefore(more, grid.nextSibling);
})();

/* ===== Ficha: animacion ydza (roll letra por letra) en el precio ===== */
(function(){
  function line(txt,cls){var s=document.createElement('span');s.className='nfp__roll__l'+(cls||'');for(var k=0;k<txt.length;k++){var c=document.createElement('i');c.style.setProperty('--i',k);c.textContent=txt[k]===' '?'\u00a0':txt[k];s.appendChild(c);}return s;}
  function roll(el){
    if(!el||el.dataset.nfr) return; el.dataset.nfr='1';
    var txt=(el.textContent||'').trim(); if(!txt) return; el.textContent='';
    var w=document.createElement('span'); w.className='nfp__roll';
    w.appendChild(line(txt,'')); w.appendChild(line(txt,' nfp__roll__l--b'));
    el.appendChild(w);
    w.classList.add('is-play'); setTimeout(function(){w.classList.remove('is-play');},900);
  }
  function run(){ document.querySelectorAll('.nfp__pay2 .nfp__opt b').forEach(roll); }
  run(); setTimeout(run,450);
})();


/* ===== Ficha: ocultar selector "Variante" cuando es Default Title (inutil) ===== */
(function(){
  var sel=document.querySelector('#nfp-var, .nfp__form .nfp__sel'); if(!sel||!sel.options) return;
  var meaningful=false;
  for(var i=0;i<sel.options.length;i++){ if(!/default title/i.test(sel.options[i].text)) meaningful=true; }
  if(!meaningful || sel.options.length<=1){
    sel.style.display='none';
    var lbl=document.querySelector('label[for="nfp-var"]'); if(lbl) lbl.style.display='none';
  }
})();

/* ===== Ficha: carrusel "misma medida, otras marcas" — usa la card de siempre (.nfc) ===== */
(function(){
  var rel=document.querySelector('.nfp__rel'); if(!rel) return;
  var t=document.querySelector('.nfp__t'); if(!t) return;
  var title=t.textContent||'';
  var mm=title.match(/(\d{2,3})\s*\/\s*(\d{2})\s*R?\s*(\d{2})/i); if(!mm) return;
  var measure=mm[1]+'/'+mm[2]+' R'+mm[3];
  var mnum=mm[1]+mm[2]+mm[3];
  var curHandle=((location.pathname.split('/products/')[1])||'').split('?')[0];
  var BRs=['Yokohama','Pirelli','Continental','Dunlop','Bridgestone','Firestone','Nexen','Linglong','Fate','Kumho','Michelin','Goodyear','Hankook','Wanli','Sunny'];
  var curBrand=''; for(var i=0;i<BRs.length;i++){ if(new RegExp('\\b'+BRs[i]+'\\b','i').test(title)){curBrand=BRs[i];break;} }
  function num(s){s=(s||'').replace(/[^0-9.,]/g,'');if(!s)return 0;s=s.replace(/\./g,'').replace(',','.');return parseFloat(s)||0;}
  function money0(n){return '$'+Math.round(n).toLocaleString('es-AR');}
    var LOGO={
    Yokohama:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/yokohama-logo.svg?v=1772562007',
    Pirelli:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/pirelli-logo-2.svg?v=1788793336',
    Continental:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/continental-6.svg?v=1772562601',
    Dunlop:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/dunlop-1.svg?v=1772562045',
    Bridgestone:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/bridgestone-3.svg?v=1772562518',
    Firestone:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/firestone-tire.svg?v=1772562910',
    Nexen:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/nexen-tire-logo-1.svg?v=1772562653',
    Linglong:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/linglong-tire-logo.svg?v=1772562715',
    Fate:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/logo-fate.svg?v=1773962753',
    Kumho:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/kumho-logo.svg?v=1788793260',
    'GT Radial':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/gt-radial-tires.svg?v=1772562825',
    GreenMax:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/greenmax-logo.svg?v=1772563006'
  };
// misma mejora que nf-shop.js aplica a la card de siempre (bloque .nfc__ap + badge efectivo)
  function enhance(c){
    if(c.dataset.pb) return;
    var pr=c.querySelector('.nfc__pr'), q=c.querySelector('.nfc__q'); if(!pr||!q) return;
    c.dataset.pb='1';
    var card=num((pr.querySelector('b')||{}).textContent), cash=num((q.querySelector('span')||{}).textContent);
    var m=(q.textContent.match(/6 cuotas de\s*(\$[\d.,]+)/)||[])[1]||money0(card/6);
    if(!card||!cash) return;
    var p=card>0?Math.round((1-cash/card)*100):0;
    var media=c.querySelector('.nfc__media');
    if(media&&p>0&&!media.querySelector('.nfa__off--sm')){var o=document.createElement('span');o.className='nfa__off nfa__off--sm';o.innerHTML='-'+p+'%<small>efectivo</small>';media.appendChild(o);}
    var box=document.createElement('div');box.className='nfc__ap';
    box.innerHTML='<div class="nfc__ap-lb">Efectivo o transferencia</div><div class="nfc__ap-main"><span class="nfc__ap-price">'+money0(cash)+'</span><span class="nfc__ap-off">-'+p+'%</span></div><div class="nfc__ap-save">Ahorrás <b>'+money0(card-cash)+'</b></div><div class="nfc__ap-card">Con tarjeta <b>'+money0(card)+'</b> · 6 cuotas de <b>'+money0(num(m))+'</b></div>';
    pr.parentNode.insertBefore(box,pr); pr.remove(); q.remove();
    var body=c.querySelector('.nfc__body'), tagEl=c.querySelector('.nfc__tag');
    if(body&&tagEl){var med=(tagEl.textContent||'').trim(); tagEl.remove(); var chip=document.createElement('span'); chip.className='nfc__medida'; chip.innerHTML='<i>Medida</i><b>'+med+'</b>'; body.insertBefore(chip, body.firstChild);}
    var vEl=c.querySelector('.nfc__v');
    if(vEl){var vn=(vEl.textContent||'').trim(),key=null; for(var kk in LOGO){ if(new RegExp('\\b'+kk+'\\b','i').test(vn)){key=kk;break;} } if(key){vEl.classList.add('nfc__v--logo'); vEl.innerHTML='<a class="nfc__v-lnk" href="/collections/'+key.toLowerCase().replace(/ /g,'-')+'" aria-label="Ver '+vn+'"><img src="'+LOGO[key]+'" alt="'+vn+'" loading="lazy"></a>';}}
  }
  var norm=function(s){return (s||'').replace(/\s+/g,'').toLowerCase();};
  var want=mnum.replace(/[^0-9]/g,'');
  var u='/search?q='+encodeURIComponent(measure)+'&type=product&section_id=nf-min-search';
  fetch(u,{headers:{'Accept':'text/html'}}).then(function(r){return r.text();}).then(function(html){
    var doc=new DOMParser().parseFromString(html,'text/html');
    var all=Array.prototype.slice.call(doc.querySelectorAll('.nfc'));
    var picked=all.filter(function(c){
      var a=c.querySelector('a.nfc__media'); if(!a) return false;
      var h=((a.getAttribute('href')||'').split('/products/')[1]||'').split('?')[0];
      var tag=((c.querySelector('.nfc__tag')||{}).textContent||'').replace(/[^0-9]/g,'');
      return h && h!==curHandle && tag.indexOf(want)>-1;
    });
    var other=[],same=[];
    picked.forEach(function(c){ var v=norm((c.querySelector('.nfc__v')||{}).textContent); if(curBrand&&v===norm(curBrand)) same.push(c); else other.push(c); });
    var list=other.concat(same).slice(0,12);
    if(!list.length) return;
    var sc=document.createElement('div'); sc.className='nfp__reco';
    list.forEach(function(c){ enhance(c); sc.appendChild(c); });
    var wrap=document.createElement('div'); wrap.className='nfp__reco-wrap';
    var prev=document.createElement('button'); prev.className='nfp__reco-nav nfp__reco-prev'; prev.type='button'; prev.setAttribute('aria-label','Anterior'); prev.innerHTML='&#8249;';
    var next=document.createElement('button'); next.className='nfp__reco-nav nfp__reco-next'; next.type='button'; next.setAttribute('aria-label','Siguiente'); next.innerHTML='&#8250;';
    wrap.appendChild(prev); wrap.appendChild(sc); wrap.appendChild(next);
    var grid=rel.querySelector('.nfm-grid');
    if(grid){ grid.parentNode.replaceChild(wrap,grid); } else { rel.appendChild(wrap); }
    var head=rel.querySelector('.nfm-h2'); if(head) head.textContent='Misma medida, otras marcas';
    var step=function(){ var c=sc.querySelector('.nfc'); return c?c.getBoundingClientRect().width+16:280; };
    prev.onclick=function(){ sc.scrollBy({left:-step(),behavior:'smooth'}); };
    next.onclick=function(){ sc.scrollBy({left:step(),behavior:'smooth'}); };
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!reduce){
      var mk=function(){return setInterval(function(){ if(sc.scrollLeft+sc.clientWidth>=sc.scrollWidth-6){ sc.scrollTo({left:0,behavior:'smooth'}); } else { sc.scrollBy({left:step(),behavior:'smooth'}); } },3500);};
      var iv=mk();
      wrap.addEventListener('mouseenter',function(){clearInterval(iv);});
      wrap.addEventListener('mouseleave',function(){iv=mk();});
    }
  }).catch(function(){});
})();

/* ===== Footer: roll ydza (mismo del header) en los links del pie ===== */
(function(){
  function line(txt,cls){var s=document.createElement('span');s.className='nf-roll__l'+(cls||'');for(var k=0;k<txt.length;k++){var c=document.createElement('i');c.style.setProperty('--i',k);c.textContent=txt[k]===' '?'\u00a0':txt[k];s.appendChild(c);}return s;}
  function roll(a){ if(!a||a.dataset.nfr) return; var txt=(a.textContent||'').trim(); if(!txt||txt.length>34) return; a.dataset.nfr='1'; a.textContent=''; var w=document.createElement('span'); w.className='nf-roll'; w.appendChild(line(txt,'')); w.appendChild(line(txt,' nf-roll__l--b')); a.appendChild(w); }
  function run(){ document.querySelectorAll('.nff__col a, .nff__legal-links a').forEach(roll); }
  if(document.readyState!='loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();

/* ===== Cards de colección/búsqueda: logo de marca + chip de medida (como el carrusel) ===== */
(function(){
  var LOGO={
    Yokohama:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/yokohama-logo.svg?v=1772562007',
    Pirelli:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/pirelli-logo-2.svg?v=1788793336',
    Continental:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/continental-6.svg?v=1772562601',
    Dunlop:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/dunlop-1.svg?v=1772562045',
    Bridgestone:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/bridgestone-3.svg?v=1772562518',
    Firestone:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/firestone-tire.svg?v=1772562910',
    Nexen:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/nexen-tire-logo-1.svg?v=1772562653',
    Linglong:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/linglong-tire-logo.svg?v=1772562715',
    Fate:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/logo-fate.svg?v=1773962753',
    Kumho:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/kumho-logo.svg?v=1788793260',
    'GT Radial':'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/gt-radial-tires.svg?v=1772562825',
    GreenMax:'https://cdn.shopify.com/s/files/1/0780/9535/1865/files/greenmax-logo.svg?v=1772563006'
  };
  function enh(c){
    if(c.dataset.nfle) return;
    if(c.closest && c.closest('.nfp__reco')) return;
    c.dataset.nfle='1';
    var body=c.querySelector('.nfc__body'), tagEl=c.querySelector('.nfc__tag');
    if(body&&tagEl&&!body.querySelector('.nfc__medida')){var med=(tagEl.textContent||'').trim(); if(med){tagEl.remove(); var chip=document.createElement('span'); chip.className='nfc__medida'; chip.innerHTML='<i>Medida</i><b>'+med+'</b>'; body.insertBefore(chip, body.firstChild);}}
    var vEl=c.querySelector('.nfc__v');
    if(vEl&&!vEl.classList.contains('nfc__v--logo')){var vn=(vEl.textContent||'').trim(),key=null; for(var kk in LOGO){ if(new RegExp('\\b'+kk+'\\b','i').test(vn)){key=kk;break;} } if(key){vEl.classList.add('nfc__v--logo'); vEl.innerHTML='<a class="nfc__v-lnk" href="/collections/'+key.toLowerCase().replace(/ /g,'-')+'" aria-label="Ver '+vn+'"><img src="'+LOGO[key]+'" alt="'+vn+'" loading="lazy"></a>';}}
  }
  function run(){ document.querySelectorAll('.nfc').forEach(enh); }
  if(document.readyState!='loading') run(); else document.addEventListener('DOMContentLoaded', run);
  setTimeout(run,600); setTimeout(run,1600);
})();

/* ===== Menú móvil: roll ydza en los links (se dispara escalonado al abrir; y al tocar) ===== */
(function(){
  function line(txt,cls){var s=document.createElement('span');s.className='nf-roll__l'+(cls||'');for(var k=0;k<txt.length;k++){var c=document.createElement('i');c.style.setProperty('--i',k);c.textContent=txt[k]===' '?'\u00a0':txt[k];s.appendChild(c);}return s;}
  function roll(a){
    if(!a||a.dataset.mroll) return; a.dataset.mroll='1';
    var tn=null; for(var i=0;i<a.childNodes.length;i++){var n=a.childNodes[i]; if(n.nodeType===3&&n.textContent.trim()){tn=n;break;}}
    if(!tn) return; var txt=tn.textContent.trim(); if(!txt) return;
    var w=document.createElement('span'); w.className='nf-roll'; w.setAttribute('aria-label',txt);
    w.appendChild(line(txt,'')); w.appendChild(line(txt,' nf-roll__l--b'));
    a.replaceChild(w,tn);
  }
  function build(){ document.querySelectorAll('.nf-mnav .mlink').forEach(roll); }
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function sync(){
    var open=document.body.classList.contains('nf-mnav-open');
    build();
    var links=document.querySelectorAll('.nf-mnav .mlink');
    if(open&&!reduce){ links.forEach(function(a,i){ a.classList.remove('is-play'); void a.offsetWidth; setTimeout(function(){a.classList.add('is-play');}, 90+i*55); }); }
    else { links.forEach(function(a){ a.classList.remove('is-play'); }); }
  }
  var mo=new MutationObserver(sync);
  mo.observe(document.body,{attributes:true,attributeFilter:['class']});
  if(document.readyState!='loading') build(); else document.addEventListener('DOMContentLoaded', build);
})();

